import { css } from '@emotion/react'
import { ReactNode } from 'react'
import { BREAKPOINTS } from 'utils/styled'
import { Caption } from 'components/Typography'
import { useRouter } from 'next/router'
import { Icon } from 'components/icon'
import { colors } from 'utils/colors'
import { useTranslation } from 'next-i18next'

export function WizardStepHeader(props: {
  current?: ReactNode
  total?: ReactNode
  onBackClick?: () => void
  hideBack?: boolean
  className?: string
}) {
  const router = useRouter()
  const { t } = useTranslation()

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        justify-content: space-between;

        @media ${BREAKPOINTS.MD.max} {
          flex-direction: column;
          align-items: flex-start;
        }
      `}
      className={props.className}
    >
      <div
        css={css`
          display: inline-flex;
          height: 24px;
          align-items: center;
          justify-content: center;
          margin-bottom: 7px;
          cursor: pointer;

          ${props.hideBack
            ? css`
                opacity: 0;
                pointer-events: none;
                @media ${BREAKPOINTS.MD.max} {
                  display: none;
                }
              `
            : css`
                opacity: 1;
                pointer-events: all;
              `}
        `}
        onClick={props.onBackClick ?? router.back}
      >
        <Icon name="ArrowLeft" color={colors.blue[500]} />
      </div>
      {props.current != null && props.total != null && (
        <Caption
          css={css`
            text-align: right;
            @media ${BREAKPOINTS.LG.max} {
              text-align: left;
            }
          `}
        >
          {t('common.wizard_step', { ...props })}
        </Caption>
      )}
    </div>
  )
}
